import React from "react";
import { InputIconProps } from "./Input.types";
import classNames from "classnames";

const InputIcon = ({
  disabled,
  icon,
  onIconClick,
  size,
  invalid,
}: InputIconProps): React.ReactElement<InputIconProps> => {
  const iconClassNames = classNames(
    "elemental-Input-icon",
    {
      "elemental-Input-icon--invalid": invalid,
      "elemental-Input-icon--disabled": disabled,
    },
    icon?.props.className
  );

  const iconButtonClassNames = classNames({
    "elemental-Input-iconButton": !!onIconClick,
    "elemental-Input-iconButton--large": size === "large",
  });

  let iconContent = null;
  if (icon) {
    iconContent = React.cloneElement(icon, {
      className: iconClassNames,
    });
  }

  if (icon && onIconClick) {
    iconContent = (
      <button
        className={iconButtonClassNames}
        onClick={onIconClick}
        disabled={disabled}
        data-testid="input-component-iconButton"
      >
        {iconContent}
      </button>
    );
  }

  return iconContent;
};

export default InputIcon;
